module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/98fe98fb348e81e9df9477fd1982a148.png";